import { render, staticRenderFns } from "./m-product.vue?vue&type=template&id=99e421d0"
import script from "./m-product.vue?vue&type=script&lang=js"
export * from "./m-product.vue?vue&type=script&lang=js"
import style0 from "./m-product.vue?vue&type=style&index=0&id=99e421d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports